import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatCheckboxChange } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { ObservatoryService } from '@services/services.module';
import { NotificationsService } from '@services/notifications/notifications.service';
import { ClientsService } from '@app/services/client/clients.service';
import { Division } from '@app/models/division.model';

@Component({
  selector: 'app-generic-modal',
  templateUrl: './generic-modal.component.html',
  styleUrls: ['./generic-modal.component.scss']
})
export class GenericModalComponent {
  @Input() dataInput: any;
  @Input() tituloBotonOperacion: string;
  @Output() DesdeHijo_ExportarOperacion: EventEmitter<any> = new EventEmitter();
  @Output() eventoCancelarDesdeHijo: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<MatCheckboxChange>;

  public divisions: Division[] = [];

  constructor(
    private translate: TranslateService,
    private notification: NotificationsService,
    private observatory: ObservatoryService,
    private clientsService: ClientsService
  ) {
    this.getDivisionsList();
  }

  getDivisionsList(): void {
    this.clientsService.getDivisions().subscribe((data: any[]) => {
      if (Array.isArray(data)) {
        this.mapDivisionsList(data);
      }
    })
  }

  mapDivisionsList(data: any[]) {
    this.divisions = data.map((x) => ({
      datDivFechaalta: x.datDivFechaalta,
      datDivFechabaja: x.datDivFechabaja,
      intDivId: x.intDivId,
      varDivCodigo: x.varDivCodigo,
      varDivDescripcion: x.varDivDescripcion,
      checked: false
    }))
  }

  toggle(option) {
    if (this.divisions.find(m => m.varDivCodigo === option.varDivCodigo)) {
      this.divisions.find(m => m.varDivCodigo === option.varDivCodigo).checked = !this.divisions.find(m => m.varDivCodigo === option.varDivCodigo).checked;
    }
  }

  aceptar() {
    if (this.divisions.find(m => m.checked === true)) {
      this.DesdeHijo_ExportarOperacion.emit(this.divisions);
      this.limpiarCancelar();
    } else {
      this.notification.setWarning(this.translate.instant('EXPORT.DEBE_SELECCIONAR'));
    }
  }

  limpiarCancelar() {
    this.eventoCancelarDesdeHijo.emit();
  }
}
